
import ExternalLink from '@/ui-kit/components/external-link';
import Icon from '@/ui-kit/components/icon';
import { IconProperty, IconType } from '@/ui-kit/components/icon/enums';
import { ExternalLinkProperty, ExternalLinkEventType } from '@/ui-kit/components/external-link/enums';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';
import { track } from '@/utils/analytics';
import { SoldDataEvent } from '@/constants/AnalyticEvents';

export default {
  name: 'SoldDataTableAddressCell',
  components: {
    ExternalLink,
    Icon,
  },
  props: {
    address: {
      default: '',
      type: String,
    },
    isBode: {
      default: false,
      type: Boolean,
    },
    href: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      ExternalLinkProperty,
      ExternalLinkEventType,
      StyleColorSchemeType,
      StyleSizeType,
      IconProperty,
      IconType,
    };
  },
  methods: {
    handleTrackAddressClick() {
      track(SoldDataEvent.AddressLinkClick, {
        Address: this.address,
      });
    },
  },
};

